import type { TranslationKey } from './en';
import core from '../bundles/hi/core';
import workspace from '../bundles/hi/workspace';
import settings from '../bundles/hi/settings';

const hi: Record<TranslationKey, string> = { ...core, ...workspace, ...settings };

export default hi;
